module.exports = __webpack_public_path__ + "static/Triangle-24dbf81d17ae0e71f7df0e4213c3b850.jpg";